import React, { useEffect, useState } from "react";
import useApiData from "../services/useApiData.js";
import ShipmentGrid from "../components/Shipping/ShipmentGrid.jsx";
import CatalogPageShell from "../components/Products/CatalogPageShell.jsx";

export default function Shipping() {
    const [shipments, setShipments] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { data, isLoading, refetch } = useApiData(
        "api/broylesllc/shipping/get-shipments",
        {
            // Quiet background refresh while viewing the grid; skip when the
            // shipment drawer is open so PrintOrder form state isn't wiped.
            refetchInterval: drawerOpen ? false : 15_000,
            refetchIntervalInBackground: false,
        }
    );

    useEffect(() => {
        if (Array.isArray(data)) setShipments(data);
    }, [data]);

    return (
        <CatalogPageShell
            title="Shipping"
            subtitle="Pending Label orders from the shared pull — print labels after Fulfillment has assigned/picked units."
        >
            <ShipmentGrid
                orders={shipments}
                loadingOrders={Boolean(isLoading)}
                closeLabel={refetch}
                onDrawerOpenChange={setDrawerOpen}
            />
        </CatalogPageShell>
    );
}
